// internal deps
import React, { memo, useEffect, useState } from "react";

// helpers
import { captureError, getCloudinaryUrl, LottieAnimation } from "@swiggy-private/core-ui";
import { updateInstructionLottieData } from "../../../helpers/InstructionLottie";

// utils
import { isEmpty } from "@swiggy-private/js-utils";

// constants
import { TOING_PC_TEST_IDS } from "@swiggy-private/cart-test-ids";

// style
import { InstructionsContainer, LottieWrapper } from "../styles";

// types
import type { IToingPriceComparisonBEData } from "../types";

// interfaces
interface IInstructionStateProps {
    instructionsData?: IToingPriceComparisonBEData["instructions_data"];
    onImpression?: VoidFunction;
}

const InstructionState: React.FC<IInstructionStateProps> = ({ instructionsData, onImpression }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [lottieData, setLottieData] = useState<any>(null);

    useEffect(() => {
        onImpression?.();
    }, [onImpression]);

    useEffect(() => {
        if (isEmpty(instructionsData?.lottie_id)) return;

        let cancelled = false;

        const fetchAndModifyLottie = async () => {
            try {
                const lottieUrl = getCloudinaryUrl(instructionsData?.lottie_id ?? "");
                const response = await fetch(lottieUrl);
                const data = await response.json();

                if (cancelled) return;

                const modifiedData = updateInstructionLottieData(data, instructionsData);
                setLottieData(modifiedData);
            } catch (error) {
                captureError(error);
            }
        };

        fetchAndModifyLottie();

        return () => {
            cancelled = true;
        };
    }, [instructionsData]);

    if (isEmpty(lottieData)) return null;

    return (
        <InstructionsContainer>
            <LottieWrapper data-testid={TOING_PC_TEST_IDS.LOTTIE}>
                <LottieAnimation
                    animationData={lottieData}
                    visible
                    playLottie
                    playIfVisible={false}
                    loop
                    autoplay
                    backwardSpeed={1}
                    forwardSpeed={1}
                    preserveAspect="xMidYMid meet"
                />
            </LottieWrapper>
        </InstructionsContainer>
    );
};

export default memo(InstructionState);
